import * as THREE from 'three';

import AbstractObject from '../misc/object';
import Arrow from './arrow';

export default class Arrow3D extends AbstractObject {

  static types = {
    direction: {
      X: 'x',
      Y: 'y',
      Z: 'z',
      NegativeX: '-x',
      NegativeY: '-y',
      NegativeZ: '-z'
    }
  };

  constructor(options) {
    super(options);
    this.arrowSize = 10;
    this.direction = this.options.direction;
    this.color = this.options.color || 0x000000;
    this.isSingle = this.options.isSingle || false;

    const { position } = this.options;

    if (!position) throw new Error('Position is a required property!');

    this.object.addMesh(this.getArrow(position, this.size));

    // if (!this.isSingle) {
    //   switch (this.direction) {
    //     case Arrow.types.direction.Y: {
    //       const vector = new THREE.Vector3(position.x, position.y + this.size, position.z);
    //       this.object.addMesh(this.getArrow(vector, -this.size));
    //       break;
    //     }
    //     case Arrow.types.direction.NegativeY: {
    //       const vector = new THREE.Vector3(position.x, position.y - this.size, position.z);
    //       this.object.addMesh(this.getArrow(vector, -this.size));
    //       break;
    //     }
    //     case Arrow.types.direction.Z: {
    //       const vector = new THREE.Vector3(position.x, position.y, position.z + this.size);
    //       this.object.addMesh(this.getArrow(vector, -this.size));
    //       break;
    //     }
    //     case Arrow.types.direction.NegativeZ: {
    //       const vector = new THREE.Vector3(position.x, position.y, position.z - this.size);
    //       this.object.addMesh(this.getArrow(vector, -this.size));
    //       break;
    //     }
    //     case Arrow.types.direction.NegativeX: {
    //       const vector = new THREE.Vector3(position.x - this.size, position.y, position.z);
    //       this.object.addMesh(this.getArrow(vector, -this.size));
    //       break;
    //     }
    //     default: {
    //       const vector = new THREE.Vector3(position.x + this.size, position.y, position.z);
    //       this.object.addMesh(this.getArrow(vector, -this.size));
    //       break;
    //     }
    //   }
    // }
  }

  get size() {
    return this.options.size;
  }

  get position() {
    return this.options.position;
  }

  getArrow(position, size) {
    const from = position;

    let to = null;
    let rotAxis = null;
    let rotAngle = null;
    switch (this.direction) {
      case Arrow.types.direction.Y: {
        to = new THREE.Vector3(position.x, position.y - size, position.z);
        rotAxis = new THREE.Vector3(1, 0, 0);
        rotAngle = Math.PI;
        break;
      }
      case Arrow.types.direction.NegativeY: {
        to = new THREE.Vector3(position.x, position.y + size, position.z);
        rotAxis = new THREE.Vector3(1, 0, 0);
        rotAngle = 0;
        break;
      }
      case Arrow.types.direction.Z: {
        to = new THREE.Vector3(position.x, position.y, position.z - size);
        rotAxis = new THREE.Vector3(1, 0, 0);
        rotAngle = -Math.PI / 2;
        break;
      }
      case Arrow.types.direction.NegativeZ: {
        to = new THREE.Vector3(position.x, position.y, position.z + size);
        rotAxis = new THREE.Vector3(1, 0, 0);
        rotAngle = Math.PI / 2;
        break;
      }
      case Arrow.types.direction.NegativeX: {
        to = new THREE.Vector3(position.x - size, position.y, position.z);
        rotAxis = new THREE.Vector3(0, 0, 1);
        rotAngle = Math.PI / 2;
        break;
      }
      default: {
        to = new THREE.Vector3(position.x + size, position.y, position.z);
        rotAxis = new THREE.Vector3(0, 0, 1);
        rotAngle = - Math.PI / 2;
        break;
      }
    }

    this.directionPosition = to;

    const direction = to.clone().sub(from);
    const length = direction.length();

    // const arrow = new THREE.ArrowHelper(direction.normalize(), from, length, this.color, this.arrowSize, this.arrowSize / 3);

    // if (this.options.disableDepthTest) {
    //   Array.prototype.forEach.call(arrow.children, (item) => {
    //     item.material.depthTest = false;
    //   });
    // }

    const arrow = new THREE.Object3D();
    const width = this.options.thickness || 2;
    const coneSize = width * 10;

    const material = new THREE.MeshLambertMaterial({
      color: this.color
    });
    const cylinderHeight = length - (this.isSingle ? coneSize : 2 * coneSize);
    const cylinderGeometry = new THREE.CylinderGeometry(width, width, cylinderHeight);
    cylinderGeometry.translate(0, this.isSingle ? -coneSize / 2 : 0, 0);

    arrow.add(new THREE.Mesh(cylinderGeometry, material));

    const coneGeometry = new THREE.ConeGeometry(width * 2, coneSize);
    const cone = new THREE.Mesh(coneGeometry, material);
    cone.position.y = length / 2 - coneSize / 2;
    arrow.add(cone);

    if (!this.isSingle){
      const secCone = cone.clone();
      secCone.position.y = -length / 2 + coneSize / 2;
      secCone.rotateX(Math.PI);
      arrow.add(secCone);
    }

    // set the origin
    arrow.position.set(from.x, from.y, from.z);

    arrow.translateOnAxis(
      this.direction.startsWith('-') ? direction.normalize().multiplyScalar(-1) : direction.normalize(), 
      this.direction.startsWith('-') ? (- length / 2) : (length / 2)
    );

    arrow.rotateOnAxis(rotAxis, rotAngle);

    return arrow;
  }

}



// WEBPACK FOOTER //
// ./src/object-view/objects/arrow3D.js